module.exports = __webpack_public_path__ + "static/media/iconCanvas04.f05c5da6.svg";